import axios from 'axios'

export default async (userId) => {
  if (!process.env.VUE_APP_STAMPYT_API_HOST || !process.env.VUE_APP_STAMPYT_API_KEY || !userId) return

  // Default instance calling stampyt api
  let instance = axios.create({
    baseURL: process.env.VUE_APP_STAMPYT_API_HOST,
    timeout: 30000
  })

  instance.defaults.headers.common['x-api-key'] = process.env.VUE_APP_STAMPYT_API_KEY
  instance.defaults.headers.post['Access-Control-Allow-Origin'] = '*'

  async function getUserOptions(userId) {
    const version = '1.28'
    const url = `/external/legacy/${version}/users/${userId}/options`

    try {
      return await instance.get(url)
    } catch (e) {
      return null
    }
  }

  const res = await getUserOptions(userId)

  return res.data
}
